import { IonToolbar, IonTitle, IonContent, IonGrid, IonText, IonButton, IonModal, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, useIonRouter } from '@ionic/react';
import { thumbsUpSharp, thumbsDownSharp } from 'ionicons/icons';
import { CommentLikeDetail } from '../data/item';
import React, { Component }  from 'react';
import { LANGUAGE, GetStr } from "../language/Language";

interface LikeErrProp {
    isOpen : any,
    onDidDismiss : any,
    adReady : any,
    watchAds : any
};
  
const LikeErrComp : React.FC<LikeErrProp> = ({ isOpen, onDidDismiss, adReady, watchAds }) => {
    
    //Initializing our router
	const router = useIonRouter();

    // go to route
    const goTo = (route : string) => {
        onDidDismiss();
        router.push(route, "forward", "push");
    }

    return (
        <IonModal
            id="dialogbox"
            isOpen={isOpen}
            initialBreakpoint={ 1 }
            onDidDismiss={onDidDismiss}>
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_NOLIKE_TITLE) }</h5></IonTitle>
                </IonToolbar>
                <IonContent>
                    <IonGrid className="ion-no-padding">
                        <IonRow>
                            <IonCol>
                            </IonCol>
                            <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                                <div><IonImg className="dialog-icon" src="/assets/img/heart_pic.png" /></div>
                                <div><IonText>{ GetStr(LANGUAGE.TXT_NOLIKE_DESC) }</IonText></div>
                                <div>
                                    <IonButton className="main-but ion-margin-top ion-margin-bottom" expand="block" onClick={onDidDismiss}>
                                        { GetStr(LANGUAGE.TXT_NOLIKE_OK) }
                                    </IonButton>
                                </div>
                                <div>
                                    <IonButton className="main-but ion-margin-top ion-margin-bottom" color="secondary" expand="block" onClick={ ()=>goTo("/token/wallet") }>
                                        { GetStr(LANGUAGE.TXT_NOLIKE_BUY) }
                                    </IonButton>
                                </div>
                                <div><IonText>{ GetStr(LANGUAGE.TXT_NOLIKE_GAME_DESC) }</IonText></div>
                                <div>
                                    <IonButton className="main-but ion-margin-top" expand="block" color="secondary" onClick={ ()=>goTo("/token/games") }>
                                        { GetStr(LANGUAGE.TXT_NOLIKE_GAME) }
                                    </IonButton>
                                </div>
                                { /* DEL - for Admob
                                    adReady ?
                                <div>
                                    <div className="ion-padding-top"><IonText>{ GetStr(LANGUAGE.TXT_NOLIKE_ADS_AVAIL) }</IonText></div>
                                    <div>
                                        <IonButton className="main-but ion-margin-top ion-margin-bottom" color="secondary "expand="block" onClick={watchAds}>
                                            { GetStr(LANGUAGE.TXT_NOLIKE_WATCH_ADS) }
                                        </IonButton>
                                    </div>
                                </div>
                                    :
                                <div>
                                    <div className="ion-padding-top"><IonText>{ GetStr(LANGUAGE.TXT_NOLIKE_ADS_UNAVAIL ) }</IonText></div>
                                    <div>
                                        <IonButton className="main-but ion-margin-top ion-margin-bottom" color="secondary "expand="block" disabled={true}>
                                            { GetStr(LANGUAGE.TXT_NOLIKE_WATCH_NOADS ) }
                                        </IonButton>
                                    </div>
                                </div>
                                */
                                }
                            </IonCol>
                            <IonCol>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonContent>
            </div>
        </IonModal>
    );
};
  
export default LikeErrComp;